// eslint-disable-next-line
import util from 'util';
import cookie from 'cookie';

import * as actionTypes from '../actionTypes';
// eslint-disable-next-line
import * as CoreApi from './api';
import * as PortalApi from '../PortalApi';

import * as coreSelectors from './selectors';

import * as serviceSelectors from '../service/selectors';
import * as serviceActions from '../service/actions';

import * as Notifications from "../Notifications";
import * as Updater from "../Updater";

import downloadjs from 'downloadjs';


/* 
 * Current state in the login flow 
 */
export const setLoginState = (loginState) => ({
  type : actionTypes.SET_LOGIN_STATE,
  payload : { loginState }
});


/*
 * This is called whenever a 401 is sent back from the API
 */
export const authenticate = () => {
  return function(dispatch, getState) {
    let loginState = coreSelectors.getLoginState(getState());

    /* If starting up, look for a session key in the cookie */
    if (loginState === 'startup') {
      var cookies = cookie.parse(document.cookie);

      /* This is set if they clicked the password reset button on the
         login page */
      if (cookies.portalUserPasswordReset) {
        dispatch(setLoginState('reset'));
        return;
      }

      if (coreSelectors.getAgentUserSession(getState())) {
        dispatch(setSessionKey(coreSelectors.getAgentUserSession(getState())));
        dispatch(updaterSubscribe());
        dispatch(setLoginState('cookie'));
        dispatch(updateUser());
        return;
      }

      if (cookies.portalUserSessionKey) {
        dispatch(setSessionKey(cookies.portalUserSessionKey));
        dispatch(updaterSubscribe());
        dispatch(setLoginState('cookie'));
        dispatch(updateUser());
        return;
      }
    }

    if (loginState !== 'reset') {
      /* If not in startup or password reset, try to create a new
         session with the identity key */
      let identityKey = localStorage.getItem("userIdentityKey");
      if (identityKey !== null) {
        dispatch(createSession(identityKey))
      } else {
        dispatch(setShowSplash(true));      
        dispatch(loginRedirect());
      }
    }
  }
}

/*
 * Cancel the password reset
 */
export const cancelPasswordReset = () => {
  return function(dispatch, getState) {
    document.cookie = 'portalUserPasswordReset=;path=/;max-age=0';
    dispatch(setLoginState('startup'));
    dispatch(updateUser());
  }
}


/*
 * Get a new session from an identity key.   If the key is no good,
 * clear it out of the local storage and go to the login screen
 */
export const createSession = (identityKey) => {
  return function(dispatch, getState) {
    CoreApi.createSession((sessionKey) => {
      dispatch(setSessionKey(sessionKey.sessionKey));
      dispatch(updaterSubscribe());      
      document.cookie='portalUserSessionKey=' + sessionKey.sessionKey;
      dispatch(updateUser());
    }, (error, status) => {
      if (status === 401) {
        localStorage.removeItem("userIdentityKey");
        dispatch(setShowSplash(true));
        dispatch(loginRedirect());
      } else {
        PortalApi.defaultErrorHandler(error, status);
      }
    }, identityKey);
  }
}

/*
 * Load the user record from the API
 */
export const updateUser = (completed) => {
  return function(dispatch, getState) {
    /* If already updating, just set the flag to update again */
    if (coreSelectors.getUpdatingUser(getState())) {
      dispatch(setUpdateUserAgain(true));
      if (typeof(completed) === 'function') {
        completed();
      }
      return;
    }
    dispatch(setUpdatingUser(true));
    dispatch(setUpdateUserAgain(false));
    CoreApi.queryUser((user) => {
      let oldUser = coreSelectors.getUser(getState());
      dispatch(setUser(user));
      dispatch(serviceActions.updateFilterAccounts());
      dispatch(serviceActions.setUpdatingHoldCalls(false));
      let loginState = coreSelectors.getLoginState(getState());
      if (loginState !== 'active') {
        dispatch(setLoginState('active'));
        dispatch(loginTasks());
        if (user.fullAccess === 'Y') {
          dispatch(fullAccessLoginTasks());
        }
      } else {
        if (oldUser.fullAccess === 'N' && user.fullAccess === 'Y') {
          dispatch(fullAccessLoginTasks());
        }
      }
      if (serviceSelectors.getFilterAccountId(getState()).length === 0 &&
          user.userAccountRoles.length > 0) {
        dispatch(serviceActions.setFilterAccountId(user.userAccountRoles[0].accountId));
      }
      dispatch(setUpdatingUser(false));
      if (coreSelectors.getUpdateUserAgain(getState())) {
        dispatch(updateUser());
      } else {
        dispatch(serviceActions.setUpdatingHoldCalls(false));
      }
      if (typeof(completed) === 'function') {
        completed();
      }
    }, (error, status, content) => {
      if (typeof(completed) === 'function') {
        completed();
      }
      dispatch(setUpdatingUser(false));
      PortalApi.defaultErrorHandler(error, status, content);
    });
  }
}

/*
 * Logout
 */
export const logout = () => {
  return function(dispatch, getState) {
    CoreApi.logout(() => {
      Notifications.pushUnsubscribe();
      localStorage.removeItem("userIdentityKey");
      dispatch(logoutRedirect());      
    });
  }
}

/*
 * This is called at login and possibly before completion of any two
 * factor or password changes to transition to full access.
 */
export const loginTasks = () => {
  return function(dispatch, getState) {
    /* Register for push notifications */
    dispatch(registerPushDevice());    

    /* Check if they should be prompted to save their login */
    let cookies = cookie.parse(document.cookie);
    let sessionKey = coreSelectors.getSessionKey(getState());
    if (cookies.portalUserIdentityKey) {
      if (localStorage.getItem("userIdentityKey") !== cookies.portalUserIdentityKey) {
        if (localStorage.getItem("sessionKeyChecked") !== sessionKey) {
          if (localStorage.getItem("neverSaveIdentity") !== 'Y') {
            // dispatch(setCheckSaveIdentity(cookies.portalUserIdentityKey));
          }
        }
      }
    }
  }
}


/*
 * This is called after gaining full access after any required two
 * factor or password change.
 * wasn't  
 */
export const fullAccessLoginTasks = () => {
  return function(dispatch, getState) {
    // dispatch(serviceActions.updateMessages());
    dispatch(serviceActions.getAllMessages());
    dispatch(serviceActions.updateStatusSelectionLists());
  }
}

/*
 * Save the identity
 */
export const saveIdentity = () => {
  return function(dispatch, getState) {
    let identityKey = coreSelectors.getCheckSaveIdentity(getState());
    localStorage.setItem('userIdentityKey', identityKey);
    dispatch(setCheckSaveIdentity(''));
  }
}


/*
 * Do not save for this session
 */
export const noSaveIdentitySession = () => {
  return function(dispatch, getState) {
    let sessionKey = coreSelectors.getSessionKey(getState());
    localStorage.setItem('sessionKeyChecked', sessionKey);
    dispatch(setCheckSaveIdentity(''));
  }
}

/*
 * Do not save for this device
 */
export const noSaveIdentityEver = () => {
  return function(dispatch, getState) {
    localStorage.setItem('neverSaveIdentity', 'Y');
    dispatch(setCheckSaveIdentity(''));
  }
}


/*
 * Snack messages are transient message displayed in a snackbar at the bottom right
 * type = success, error, info, warning
 */
export const postSnackMessage = (type, title, message, duration) => {
  return function(dispatch, getState) {
    let snackMessageQueue = coreSelectors.getSnackMessageQueue(getState());
    let SnackMessageItem = coreSelectors.getSnackMessageItem(getState());
    let key = (SnackMessageItem?.key ?? 0) + 1;
    snackMessageQueue.forEach(item => {
      if (item.key >= key) {
        key = item.key + 1;
      }
    });
    let newItem = {
      open : true,
      type,
      key,
      title,
      message,
      duration,
    };
    if (SnackMessageItem) {
      dispatch(setSnackMessageQueue([ ...snackMessageQueue, newItem]));
    } else {
      dispatch(setSnackMessageItem(newItem));
    }
  }
}


/* */
export const setUser = (user) => ({
  type : actionTypes.SET_USER,
  payload : { user }
});

/* Redirect to login */
export const loginRedirect =() => {
  return function(dispatch, getState) {
    var redirectUrl = PortalApi.BaseUrl() + '/login';    
    if (window.location.port === "3000") {
      window.location.href = redirectUrl + '?returnUrl=' + encodeURIComponent(window.location.origin);
    } else {
      window.location.href = redirectUrl;
    }
  }
}

/* Redirect to logout */
export const logoutRedirect =() => {
  return function(dispatch, getState) {
    window.location.href = PortalApi.BaseUrl() + '/logout';
  }
}


/* */
export const setSessionKey = (sessionKey) => ({
  type : actionTypes.SET_SESSION_KEY,
  payload : { sessionKey }
});


/* */
export const setSnackMessageQueue = (snackMessageQueue) => ({
  type : actionTypes.SET_SNACK_MESSAGE_QUEUE,
  payload : { snackMessageQueue }
});

/* */
export const setSnackMessageItem = (snackMessageItem) => ({
  type : actionTypes.SET_SNACK_MESSAGE_ITEM,
  payload : { snackMessageItem }
});



/* */
export const setAvailableScreens = (availableScreens) => ({
  type : actionTypes.SET_AVAILABLE_SCREENS,
  payload : { availableScreens }
});

/* */
export const setShowSplash = (showSplash) => ({
  type : actionTypes.SET_SHOW_SPLASH,
  payload : { showSplash }
});

/* */
export const setCheckSaveIdentity = (checkSaveIdentity) => ({
  type : actionTypes.SET_CHECK_SAVE_IDENTITY,
  payload : { checkSaveIdentity }
});


/* Send an SMS two factor code for the current session */
export const sendTwoFactor = (email, success, failure) => {
  return function(dispatch, getState) {
    CoreApi.sendTwoFactor(() => {
      if (typeof(success) === 'function') {
        success();
      }
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      if (typeof(failure) === 'function') {
        failure();
      }
    }, email);
  }
}

/* Send an SMS two factor code for the current session */
export const verifyTwoFactor = (twoFactorCode, success, failure) => {
  return function(dispatch, getState) {
    CoreApi.verifyTwoFactor((changeKey) => {
      dispatch(setPasswordChangeKey(changeKey.passwordChangeKey));
      /* Actually gets an hour but allow 15 minutes to put in the password */
      let expiration = new Date();
      expiration.setMinutes(expiration.getMinutes() + 45);
      dispatch(setPasswordChangeKeyExpiration(expiration));
      dispatch(updateUser());
      if (typeof(success) === 'function') {
        success();
      }
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      if (typeof(failure) === 'function') {
        failure();
      }
    }, twoFactorCode);
  }
}

/* Change the password.  Requires the passwordChangeKey is valid */
export const changePassword = (password, completed) => {
  return function(dispatch, getState) {
    let passwordChangeKey = coreSelectors.getPasswordChangeKey(getState());
    CoreApi.changePassword(() => {
      if (typeof(completed) === 'function') {
        completed();
      }
      dispatch(updateUser());
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      if (typeof(completed) === 'function') {
        completed();
      }
    }, passwordChangeKey, password);
  }
}


/* */
export const setPasswordChangeKey = (passwordChangeKey) => ({
  type : actionTypes.SET_PASSWORD_CHANGE_KEY,
  payload : { passwordChangeKey }
});

/* */
export const setPasswordChangeKeyExpiration = (passwordChangeKeyExpiration) => ({
  type : actionTypes.SET_PASSWORD_CHANGE_KEY_EXPIRATION,
  payload : { passwordChangeKeyExpiration }
});

/* */
export const setManualPasswordChange = (manualPasswordChange) => ({
  type : actionTypes.SET_MANUAL_PASSWORD_CHANGE,
  payload : { manualPasswordChange }
});

export const sendPasswordResetCode = (mobile, email, success, failure) => {
  return function(dispatch, getState) {
    CoreApi.sendPasswordResetCode(() => {
      if (typeof(success) === 'function') {
        success();
      }
    }, (error, status, content) => {
      if (typeof(failure) === 'function') {
        failure(error, status, content);
      } else {
        PortalApi.defaultErrorHandler(error, status, content);
      }
    }, mobile, email);
  }
}

export const resetPassword = (mobile, email, twoFactorCode, success, failure) => {
  return function(dispatch, getState) {
    CoreApi.resetPassword(() => {
      if (typeof(success) === 'function') {
        success();
      }
    }, (error, status, content) => {
      if (typeof(failure) === 'function') {
        failure(error, status, content);
      } else {
        PortalApi.defaultErrorHandler(error, status, content);
      }
    }, mobile, email, twoFactorCode);
  }
}

/*
 * Setup the push notification values and attempt to register
 */
export const setupPushNotification = (endpoint, pushKey, pushAuth) => {
  return function(dispatch, getState) {
    dispatch(setPushEndpoint(endpoint));
    dispatch(setPushKey(pushKey));
    dispatch(setPushAuth(pushAuth));
    dispatch(registerPushDevice());
  }
}

/*
 * Attempt to register the push notifcation device
 */
export const registerPushDevice = () => {
  return function(dispatch, getState) {
    if (coreSelectors.getLoginState(getState()) === 'active') {
      let endpoint = coreSelectors.getPushEndpoint(getState());
      if (endpoint != null && endpoint.length > 0) {
        CoreApi.registerPushDevice(null,
                                   (error, status, content) =>  {
                                     if (status !== 403) {
                                       PortalApi.defaultErrorHandler(error, status, content);
                                     }
                                   },
                                   coreSelectors.getPushEndpoint(getState()),
                                   coreSelectors.getPushKey(getState()),
                                   coreSelectors.getPushAuth(getState()));
      }
    }
  }
}

/* */
export const setPushEndpoint = (pushEndpoint) => ({
  type : actionTypes.SET_PUSH_ENDPOINT,
  payload : { pushEndpoint }
});

/* */
export const setPushKey = (pushKey) => ({
  type : actionTypes.SET_PUSH_KEY,
  payload : { pushKey }
});

/* */
export const setPushAuth = (pushAuth) => ({
  type : actionTypes.SET_PUSH_AUTH,
  payload : { pushAuth }
});

/*
 * Update the subscrition on the websocket.  This should be called
 * whenever the session key changes
*/
export const updaterSubscribe = () => {
  return function(dispatch, getState) {
    Updater.Subscribe();
  }
}

/* */
export const setUpdatingUser = (updatingUser) => ({
  type : actionTypes.SET_UPDATING_USER,
  payload : { updatingUser }
});

/* */
export const setUpdateUserAgain = (updateUserAgain) => ({
  type : actionTypes.SET_UPDATE_USER_AGAIN,
  payload : { updateUserAgain }
});

/*
* Download the state
*/
export const dumpState = () => {
  return function(dispatch, getState) {
    downloadjs(JSON.stringify(getState(), null, 2), 'state.txt', 'text/plain');
  }
}

/* */
export const setBusyOpen = (busyOpen) => ({
  type : actionTypes.SET_BUSY_OPEN,
  payload : { busyOpen }
});

/* */
export const setBusyMessage = (busyMessage) => ({
  type : actionTypes.SET_BUSY_MESSAGE,
  payload : { busyMessage }
});

/* Open a busy modal for critical functions */
export const openBusy = (message) => {
  return function(dispatch, getState) {
    dispatch(setBusyMessage(message));
    dispatch(setBusyOpen(true));
  }
}

/* Close the busy box */
export const closeBusy = () => {
  return function(dispatch, getState) {
    dispatch(setBusyOpen(false));
  }
}

/* */
export const setApiInfo = (apiInfo) => ({
  type : actionTypes.SET_API_INFO,
  payload : { apiInfo }
});

export const updateApiInfo = () => {
  return function(dispatch, getState) {
    CoreApi.getApiInfo((apiInfo) => {
      dispatch(setApiInfo(apiInfo));
    }, () => {});
  }
}

export const changeAccessPin = (accessPin, completed, failed) => {
  return function(dispatch, getState) {
    CoreApi.changeAccessPin(() => {
      dispatch(updateUser());
      if (typeof(completed) === 'function') {
        completed();
      }
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      if (typeof(failed) === 'function') {
        failed();
      }
    }, accessPin);
  }
}

export const ackNotification = (usageNotificationId, completed, failed) => {
  return function(dispatch, getState) {
    CoreApi.ackNotification(() => {
      dispatch(updateUser());
      if (typeof(completed) === 'function') {
        completed();
      }
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      if (typeof(failed) === 'function') {
        failed();
      }
    }, usageNotificationId);
  }
}


/* */
export const setAgentUserSession = (agentUserSession) => ({
  type : actionTypes.SET_AGENT_USER_SESSION,
  payload : { agentUserSession }
});
